<template>
    <b-card no-body class='px-2 py-4 p-md-4'>
        <b-container>
            <b-row class='box'>
                <b-col cols=2  class='pt-3 pt-md-1' style='padding: 2px 0px 0px 0px;'>
                    <div class='icon'>
                        <div class='wraper'>
                            <component
                                :is="item.component"
                                v-bind='item.properties'
                            />
                        </div>
                    </div>
                </b-col>
                <b-col cols=10 class='text-right'>
                    <b-row>
                        <b-col cols=12>
                            <h5 class='txt-color-primary title'> {{item.title}}</h5>
                        </b-col>
                        <b-col cols=12>
                            <h5 class='txt-color-secondary value'> {{item.value}}</h5>
                        </b-col>
                        <b-col cols=12>
                            <h6 class='txt-color-tertiary symbol'> {{item.symbol}}</h6>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            </b-container>
    </b-card>
</template>
<script>
export default { props: ['item'] }
</script>

<style scoped>
h5,h6{
    font-family: "Poppins-Light";
    font-style: normal;
    font-weight: 500;
    margin-bottom: 0px;
}
.txt-color-primary {
    color: #F4C96C;
}
.txt-color-secondary {
    color: #FFFFFF;
}
.txt-color-tertiary{
    color: #A7A4A4;
}
.box {
    background-color: transparent !important;
}
.box .icon {
    display: table;
    height: 37px;
    width: 37px;
    margin: auto;
    border-radius: 25px;
    background-color: #F4C96C;
}
.box .icon .wraper{
    display: table-cell;
    vertical-align: middle;
    text-align: center;
}
.box .value {
    font-weight: bold;
}
@media screen and (min-width: 576px) {
    .box .icon {
        height: 57px;
        width: 60px;
        border-radius: 30px;
    }
}
</style>
